export const setStorageTimestamp = (value) => {
  sessionStorage.setItem('timestampData', String(value.unix()));
};

export const getStorageTimestamp = () => {
  const timestampSelectedDate = sessionStorage.getItem('timestampData');
  return timestampSelectedDate ? +timestampSelectedDate : 0;
};

export const removeStorageTimestamp = () => {
  if (!sessionStorage.getItem('timestampData')) return;
  sessionStorage.removeItem('timestampData');
};

export const setStorageAdminDownload = (value) => {
  sessionStorage.setItem('AdminDownloadQuery', JSON.stringify(value));
};

export const getStorageAdminDownload = () => {
  const AdminDownloadQuery = sessionStorage.getItem('AdminDownloadQuery');
  return AdminDownloadQuery ? JSON.parse(AdminDownloadQuery) : false;
};

export const removeStorageAdminDownload = () => {
  if (!sessionStorage.getItem('AdminDownloadQuery')) return;
  sessionStorage.removeItem('AdminDownloadQuery');
};
